
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.006 6.918a.838.838 0 01-.594-.246l-5.16-5.16A.84.84 0 111.441.325L6.006 4.89 10.572.324a.84.84 0 011.188 1.189L6.6 6.673a.838.838 0 01-.594.245z","fill":"#7D7D7D"}})])
          )
        }
      }
    